const DASHBOARD_ROUTE = '/dashboard';
const WELCOME_ROUTE = '/welcome';

export const LandingRouteService = {
  getHomeRoute: (): string => {
    return DASHBOARD_ROUTE;
  },
  getDashboardRoute: (): string => {
    return DASHBOARD_ROUTE;
  },
  getWelcomeRoute: (): string => {
    return WELCOME_ROUTE;
  }
};
